import { publicRoutes } from "@/components/shared/routes";

/**
 * Routes whose page IS the full experience (error / status / 404 pages).
 * These render with no site chrome and must NOT be auth-redirected. They
 * supply their own full-screen UI, so the global theatrical boot sequence
 * (LoadingSequence) should be skipped on them — the page is the content.
 */
export const standaloneRoutes = [
  "/404",
  "/500",
  "/403",
  "/offline",
  "/success",
  "/loading",
  "/rate-limited",
  "/maintenance",
  "/splash",
];

/**
 * True when `pathname` is a standalone full-page route: an explicit member of
 * `standaloneRoutes`, or any unknown path that is neither a public route nor an
 * auth route (i.e. a deep-link 404 / unmatched route).
 */
export function isStandaloneRoute(pathname: string): boolean {
  return (
    standaloneRoutes.includes(pathname) ||
    (!publicRoutes.includes(pathname) &&
      !pathname.startsWith("/auth/") &&
      !publicRoutes.some((p) => pathname.startsWith(p)))
  );
}
